import { render, staticRenderFns } from "./Customers2.vue?vue&type=template&id=75b0b712&"
import script from "./Customers2.vue?vue&type=script&lang=js&"
export * from "./Customers2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports